import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  setCursorTooltip,
  updateTool,
} from '../../../../redux/actions/fabric_overlay';
import Button from './../Toolbar/Button';
import { connect } from 'react-redux';
import ThinIcon from '../../images/Icon20_Pencil.svg';
import { getThicknessPx, hexToRgba } from '../../helpers/fabricHelpers';
import { __ } from '../../../../core/utils';

function Pencil({
  fabric_overlay: { viewer, fabricOverlay, color, selectedThickness },
  isActive,
  plan,
  user_id,
  user_full_name,
}) {
  const handleClick = () => {
    if (!isActive) updateTool({ tool: 'pencil' });
  };

  useEffect(() => {
    if (!fabricOverlay || !isActive) return;
    const canvas = fabricOverlay.fabricCanvas();

    const handleMouseUp = () => {
      viewer.setMouseNavEnabled(true);
    };

    const onPathCreated = (e) => {
      const obj = e.path;
      if (obj) {
        obj.objectType = 'freehand';
        obj.userID = user_id;
        obj.userFullName = user_full_name;
        obj.lockScalingX = true;
        obj.lockScalingY = true;
        obj.hasControls = false;
        obj.hasBorders = false;
        obj.perPixelTargetFind = true;

        obj.lastGoodScaleX = obj.scaleX;
        obj.lastGoodScaleY = obj.scaleY;
        obj.lastGoodLeft = obj.left;
        obj.lastGoodTop = obj.top;

        obj.setCoords();
        viewer.setMouseNavEnabled(true);
      }
    };

    const onPointerDown = () => viewer.setMouseNavEnabled(false);

    canvas.upperCanvasEl.addEventListener('pointerdown', onPointerDown);
    canvas.on('path:created', onPathCreated);
    canvas.on('mouse:up', handleMouseUp);

    return () => {
      canvas.off('path:created', onPathCreated);
      canvas.off('mouse:up', handleMouseUp);
      canvas.upperCanvasEl.removeEventListener('pointerdown', onPointerDown);
    };
  }, [fabricOverlay, isActive, user_id, viewer]);

  useEffect(() => {
    if (!fabricOverlay || !isActive) return;
    const canvas = fabricOverlay.fabricCanvas();

    canvas.defaultCursor = 'crosshair';
    canvas.isDrawingMode = true;

    setCursorTooltip(__('canvas.tooltip.free_draw'));

    canvas.freeDrawingBrush.color = color.hex;
    canvas.freeDrawingBrush.width = getThicknessPx(
      selectedThickness.key,
      'pencil'
    );

    const originalGetPointer = canvas.getPointer.bind(canvas);
    canvas.getPointer = (e, ignoreZoom) => {
      const pointer = originalGetPointer(e, ignoreZoom);
      return {
        x: Math.max(0, Math.min(plan.width, pointer.x)),
        y: Math.max(0, Math.min(plan.height, pointer.y)),
      };
    };

    return () => {
      canvas.isDrawingMode = false;
    };
  }, [fabricOverlay, isActive, selectedThickness, color, plan]);

  return (
    <Button
      id='pencil'
      label={__('canvas.toolbar.pencil')}
      icon={ThinIcon}
      active={isActive}
      onClick={handleClick}
    />
  );
}

Pencil.propTypes = {
  isActive: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  fabric_overlay: state.fabric_overlay,
  user_id: state.auth.id,
  user_full_name: state.auth.firstname + ' ' + state.auth.lastname,
});

export default connect(mapStateToProps, null)(Pencil);
